import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'astrato-root',
  template: '<router-outlet></router-outlet>',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppComponent {}
